<mat-form-field [floatLabel]="matFloatLabel">
  <mat-label *ngIf="matLabel"> {{ matLabel }} </mat-label>

  <input
    #strInput
    matInput
    type="text"
    autocomplete="off"
    [formControl]="strControl"
    [placeholder]="matPlaceholder"
    mask="Hh:m0"
    [dropSpecialCharacters]="false"
    [showMaskTyped]="true"
    [required]="required"
    [errorStateMatcher]="isErrorState"
    [class.text-success]="hasAutomatedData && isAutomatedValue"
    (change)="trigger($event)"
    (blur)="trigger($event)"
  />
  <span matSuffix> <ng-content select="[matSuffix]"></ng-content> </span>
  <button
    *ngIf="hasAutomatedData && !isAutomatedValue"
    mat-button
    matSuffix
    mat-icon-button
    aria-label="Refresh"
    (click)="resetAutomatedValue()"
  >
    <mat-icon>cached</mat-icon>
  </button>

  <!-- hint -->
  <mat-hint *ngIf="leftHint" align="start">
    <span class="hint-label">{{ leftHintType }}: </span>
    <span class="value" *ngFor="let dur of leftHint; first as isFirst">
      <span *ngIf="isFirst">{{ dur }} </span>
      <span *ngIf="!isFirst"> / {{ dur }}</span>
    </span>
  </mat-hint>
  <mat-hint class="right-hint" *ngIf="rightHint" align="end">
    <span class="hint-label">{{ rightHintType }}: </span>
    <span *ngFor="let dur of rightHint; first as isFirst">
      <span *ngIf="isFirst">{{ dur }} </span>
      <span *ngIf="!isFirst"> / {{ dur }}</span>
    </span>
  </mat-hint>

  <!-- error -->
  <mat-error> <ng-content select="mat-error"></ng-content> </mat-error>
</mat-form-field>
